<template>
    <div class="panel">
        <transition name="slide" appear>
            <img :src="require('@/assets/images/panel_graphics/importance.png')" alt="">
        </transition>
    </div>
</template>

<script>
    import response from '@/stores/response.js'

    export default {
        name: 'Importance_panel',
        created: function () {
            CodeBaby.jQuery('.no-nlp:hidden').show();
            CodeBaby.jQuery('.codebaby-stt-button:hidden').show();
        }
    }
</script>
<style scoped lang="stylus">
.panel
    text-align: center
    background: none !important
    .slide-enter, .slide-leave-to
        transform: translateY(-100%)
    .slide-leave-active, .slide-enter-active
        transition: 1s
</style>